import type { IRigSummary } from './rig-summary';

export class LoadingRigSummary implements IRigSummary {
  readonly rigId: number;

  constructor(rigId: number) {
    this.rigId = rigId;
  }
}
